import { AuxiliumComponent } from "../auxilium-component";

export default class ContextMenu extends AuxiliumComponent {
	static observable = ["target"];

	constructor() {
		super();

		this.onopen = this.getAttribute("onopen");
		this.onopened = this.getAttribute("onopened");
		this.boundarySpacing = parseInt(this.getAttribute("boundary-spacing")) || 5;

		this.refreshTargets();
	}

	refreshTargets() {
		if (this.target) {
			document.querySelectorAll(this.target).forEach(element => {
				element.oncontextmenu = event => this.#OnTargetClick(event);
			});
		}
	}

	static refreshTargets = () => document.querySelectorAll("chip-contextmenu").forEach(menu => menu.refreshTargets());

	parsedCallback() {
		const list = document.createElementWithContents("ul", null, {
			className: "context-menu-items"
		});

		for (const item of [...this.children]) {
			this.addItem(item, false, list);
		}

		this.appendChild(list);
	}

	addItem(item, atStart, list) {
		const listItem = document.createElementWithContents("li", item, {
			className: "context-menu-item"
		}),
			mainList = list ?? this.querySelector(".context-menu-items");

		if (listItem.querySelector("chip-menuitem chip-menuitem")) {
			listItem.classList.add("context-sub-menu-item");
		}

		if (!atStart) {
			mainList.appendChild(listItem);
		} else {
			mainList.prepend(listItem);
		}
	}

	#OnTargetClick(event) {
		if (event.target?.closest("chip-contextmenu")) { return; }

		const attemptedCoords = {
			X: this.#GetXCoord(event),
			Y: this.#GetYCoord(event)
		};

		if (attemptedCoords) {
			this.relatedTarget = event.target;

			if (this.onopen?.(event) !== false) {
				event.preventDefault();
				this.OpenMenu(attemptedCoords.X, attemptedCoords.Y);
			}
		}
	}

	#GetXCoord(event) {
		if (event.pageX) {
			return event.pageX - (document.documentElement?.scrollLeft ?? document.body.scrollLeft);
		} else if (event.clientX) {
			return event.clientX + (document.documentElement?.scrollLeft ?? document.body.scrollLeft);
		}

		return null;
	}

	#GetYCoord(event) {
		if (event.pageY) {
			return event.pageY - (document.documentElement?.scrollTop ?? document.body.scrollTop);
		} else if (event.clientY) {
			return event.clientY + (document.documentElement?.scrollTop ?? document.body.scrollTop);
		}

		return null;
	}

	OpenMenu(x, y) {
		this.onopened?.(this);
		this.OpeningCallback?.(this);

		if (!this.disabled) {
			this.#PositionMenu(x, y);

			this.querySelector(".context-menu-items")?.classList.add("context-menu-shown");
		}
	}

	#GetWidth() {
		return Math.max(parseFloat(window.getComputedStyle(this.querySelector("ul")).width) || 0,
			...Array.from(this.querySelectorAll("ul")).map(x => parseFloat(window.getComputedStyle(x).width) || 0));
	}

	#PositionMenu(x, y) {
		const computed = window.getComputedStyle(this.querySelector("ul"));

		if (computed) {
			const position = {
				y: Math.min(y, document.body.clientHeight - (parseFloat(computed.height) || 0) - this.boundarySpacing),
				x: Math.min(x, document.body.clientWidth - this.#GetWidth() - this.boundarySpacing)
			};

			Object.assign(this.querySelector(".context-menu-items").style, {
				top: `${position.y}px`,
				left: `${position.x}px`
			});
		}
	}

	Close() {
		[...window.document.querySelectorAll(".context-menu-shown")]
			.forEach(x => x.classList.remove("context-menu-shown"));

		document.querySelectorAll(".context-sub-menu-item").forEach(x => x.classList.remove("show"));
	}

	HandleMenuBlurEvent(event) {
		if (event.button !== 2 && !event.target?.closest(".context-menu-item")) {
			this.Close();
		}
	}
}
